exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".full-width-content-area .job-card .job-defs{width:67%;font-size:16px}.full-width-content-area .job-card .job-defs h3 a{font-size:20px;font-weight:700;text-decoration:underline;color:#5fa6a9}@media only screen and (min-device-width:1000px) and (min-width:1000px){.full-width-content-area .job-card .job-defs{width:auto}.full-width-content-area .job-card.no-image .job-defs,.full-width-content-area .job-card.no-image .key-stats,.full-width-content-area .job-card.no-image>p{padding-left:128px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/components/detailedJobItem/detailedJobItem.styl
// module id = 51
// module chunks = 0 1